if(typeof lazySizes === 'undefined'){
	/*! lazysizes - v4.1.8 */
  !function (a, b) { var c = b(a, a.document); a.lazySizes = c, "object" == typeof module && module.exports && (module.exports = c) }(window, function (a, b) { "use strict"; if (b.getElementsByClassName) { var c, d, e = b.documentElement, f = a.Date, g = a.HTMLPictureElement, h = "addEventListener", i = "getAttribute", j = a[h], k = a.setTimeout, l = a.requestAnimationFrame || k, m = a.requestIdleCallback, n = /^picture$/i, o = ["load", "error", "lazyincluded", "_lazyloaded"], p = {}, q = Array.prototype.forEach, r = function (a, b) { return p[b] || (p[b] = new RegExp("(\\s|^)" + b + "(\\s|$)")), p[b].test(a[i]("class") || "") && p[b] }, s = function (a, b) { r(a, b) || a.setAttribute("class", (a[i]("class") || "").trim() + " " + b) }, t = function (a, b) { var c; (c = r(a, b)) && a.setAttribute("class", (a[i]("class") || "").replace(c, " ")) }, u = function (a, b, c) { var d = c ? h : "removeEventListener"; c && u(a, b), o.forEach(function (c) { a[d](c, b) }) }, v = function (a, d, e, f, g) { var h = b.createEvent("Event"); return e || (e = {}), e.instance = c, h.initEvent(d, !f, !g), h.detail = e, a.dispatchEvent(h), h }, w = function (b, c) { var e; !g && (e = a.picturefill || d.pf) ? (c && c.src && !b[i]("srcset") && b.setAttribute("srcset", c.src), e({ reevaluate: !0, elements: [b] })) : c && c.src && (b.src = c.src) }, x = function (a, b) { return (getComputedStyle(a, null) || {})[b] }, y = function (a, b, c) { for (c = c || a.offsetWidth; c < d.minSize && b && !a._lazysizesWidth;)c = b.offsetWidth, b = b.parentNode; return c }, z = function () { var a, c, d = [], e = [], f = d, g = function () { var b = f; for (f = d.length ? e : d, a = !0, c = !1; b.length;)b.shift()(); a = !1 }, h = function (d, e) { a && !e ? d.apply(this, arguments) : (f.push(d), c || (c = !0, (b.hidden ? k : l)(g))) }; return h._lsFlush = g, h }(), A = function (a, b) { return b ? function () { z(a) } : function () { var b = this, c = arguments; z(function () { a.apply(b, c) }) } }, B = function (a) { var b, c = 0, e = d.throttleDelay, g = d.ricTimeout, h = function () { b = !1, c = f.now(), a() }, i = m && g > 49 ? function () { m(h, { timeout: g }), g !== d.ricTimeout && (g = d.ricTimeout) } : A(function () { k(h) }, !0); return function (a) { var d; (a = !0 === a) && (g = 33), b || (b = !0, d = e - (f.now() - c), d < 0 && (d = 0), a || d < 9 ? i() : k(i, d)) } }, C = function (a) { var b, c, d = 99, e = function () { b = null, a() }, g = function () { var a = f.now() - c; a < d ? k(g, d - a) : (m || e)(e) }; return function () { c = f.now(), b || (b = k(g, d)) } }; !function () { var b, c = { lazyClass: "lazyload", loadedClass: "lazyloaded", loadingClass: "lazyloading", preloadClass: "lazypreload", errorClass: "lazyerror", autosizesClass: "lazyautosizes", srcAttr: "data-src", srcsetAttr: "data-srcset", sizesAttr: "data-sizes", minSize: 40, customMedia: {}, init: !0, expFactor: 1.5, hFac: .8, loadMode: 2, loadHidden: !0, ricTimeout: 0, throttleDelay: 125 }; d = a.lazySizesConfig || a.lazysizesConfig || {}; for (b in c) b in d || (d[b] = c[b]); a.lazySizesConfig = d, k(function () { d.init && F() }) }(); var D = function () { var g, l, m, o, p, y, D, F, G, H, I, J, K = /^img$/i, L = /^iframe$/i, M = "onscroll" in a && !/(gle|ing)bot/.test(navigator.userAgent), N = 0, O = 0, P = 0, Q = -1, R = function (a) { P-- , (!a || P < 0 || !a.target) && (P = 0) }, S = function (a) { return null == J && (J = "hidden" == x(b.body, "visibility")), J || "hidden" != x(a.parentNode, "visibility") && "hidden" != x(a, "visibility") }, T = function (a, c) { var d, f = a, g = S(a); for (F -= c, I += c, G -= c, H += c; g && (f = f.offsetParent) && f != b.body && f != e;)(g = (x(f, "opacity") || 1) > 0) && "visible" != x(f, "overflow") && (d = f.getBoundingClientRect(), g = H > d.left && G < d.right && I > d.top - 1 && F < d.bottom + 1); return g }, U = function () { var a, f, h, j, k, m, n, p, q, r, s, t, u = c.elements; if ((o = d.loadMode) && P < 8 && (a = u.length)) { for (f = 0, Q++; f < a; f++)if (u[f] && !u[f]._lazyRace) if (!M || c.prematureUnveil && c.prematureUnveil(u[f])) aa(u[f]); else if ((p = u[f][i]("data-expand")) && (m = 1 * p) || (m = O), r || (r = !d.expand || d.expand < 1 ? e.clientHeight > 500 && e.clientWidth > 500 ? 500 : 370 : d.expand, c._defEx = r, s = r * d.expFactor, t = d.hFac, J = null, O < s && P < 1 && Q > 2 && o > 2 && !b.hidden ? (O = s, Q = 0) : O = o > 1 && Q > 1 && P < 6 ? r : N), q !== m && (y = innerWidth + m * t, D = innerHeight + m, n = -1 * m, q = m), h = u[f].getBoundingClientRect(), (I = h.bottom) >= n && (F = h.top) <= D && (H = h.right) >= n * t && (G = h.left) <= y && (I || H || G || F) && (d.loadHidden || S(u[f])) && (l && P < 3 && !p && (o < 3 || Q < 4) || T(u[f], m))) { if (aa(u[f]), k = !0, P > 9) break } else !k && l && !j && P < 4 && Q < 4 && o > 2 && (g[0] || d.preloadAfterLoad) && (g[0] || !p && (I || H || G || F || "auto" != u[f][i](d.sizesAttr))) && (j = g[0] || u[f]); j && !k && aa(j) } }, V = B(U), W = function (a) { var b = a.target; if (b._lazyCache) return void delete b._lazyCache; R(a), s(b, d.loadedClass), t(b, d.loadingClass), u(b, Y), v(b, "lazyloaded") }, X = A(W), Y = function (a) { X({ target: a.target }) }, Z = function (a, b) { try { a.contentWindow.location.replace(b) } catch (c) { a.src = b } }, $ = function (a) { var b, c = a[i](d.srcsetAttr); (b = d.customMedia[a[i]("data-media") || a[i]("media")]) && a.setAttribute("media", b), c && a.setAttribute("srcset", c) }, _ = A(function (a, b, c, e, f) { var g, h, j, l, o, p; (o = v(a, "lazybeforeunveil", b)).defaultPrevented || (e && (c ? s(a, d.autosizesClass) : a.setAttribute("sizes", e)), h = a[i](d.srcsetAttr), g = a[i](d.srcAttr), f && (j = a.parentNode, l = j && n.test(j.nodeName || "")), p = b.firesLoad || "src" in a && (h || g || l), o = { target: a }, s(a, d.loadingClass), p && (clearTimeout(m), m = k(R, 2500), u(a, Y, !0)), l && q.call(j.getElementsByTagName("source"), $), h ? a.setAttribute("srcset", h) : g && !l && (L.test(a.nodeName) ? Z(a, g) : a.src = g), f && (h || l) && w(a, { src: g })), a._lazyRace && delete a._lazyRace, t(a, d.lazyClass), z(function () { var b = a.complete && a.naturalWidth > 1; p && !b || (b && s(a, "ls-is-cached"), W(o), a._lazyCache = !0, k(function () { "_lazyCache" in a && delete a._lazyCache }, 9)), "lazy" == a.loading && P-- }, !0) }), aa = function (a) { if (!a._lazyRace) { var b, c = K.test(a.nodeName), e = c && (a[i](d.sizesAttr) || a[i]("sizes")), f = "auto" == e; (!f && l || !c || !a[i]("src") && !a.srcset || a.complete || r(a, d.errorClass) || !r(a, d.lazyClass)) && (b = v(a, "lazyunveilread").detail, f && E.updateElem(a, !0, a.offsetWidth), a._lazyRace = !0, P++ , _(a, b, f, e, c)) } }, ba = C(function () { d.loadMode = 3, V() }), ca = function () { 3 == d.loadMode && (d.loadMode = 2), ba() }, da = function () { if (!l) { if (f.now() - p < 999) return void k(da, 999); l = !0, d.loadMode = 3, V(), j("scroll", ca, !0) } }; return { _: function () { p = f.now(), c.elements = b.getElementsByClassName(d.lazyClass), g = b.getElementsByClassName(d.lazyClass + " " + d.preloadClass), j("scroll", V, !0), j("resize", V, !0), a.MutationObserver ? new MutationObserver(V).observe(e, { childList: !0, subtree: !0, attributes: !0 }) : (e[h]("DOMNodeInserted", V, !0), e[h]("DOMAttrModified", V, !0), setInterval(V, 999)), j("hashchange", V, !0), ["focus", "mouseover", "click", "load", "transitionend", "animationend", "webkitAnimationEnd"].forEach(function (a) { b[h](a, V, !0) }), /d$|^c/.test(b.readyState) ? da() : (j("load", da), b[h]("DOMContentLoaded", V), k(da, 2e4)), c.elements.length ? (U(), z._lsFlush()) : V() }, checkElems: V, unveil: aa, _aLSL: ca } }(), E = function () { var a, c = A(function (a, b, c, d) { var e, f, g; if (a._lazysizesWidth = d, d += "px", a.setAttribute("sizes", d), n.test(b.nodeName || "")) for (e = b.getElementsByTagName("source"), f = 0, g = e.length; f < g; f++)e[f].setAttribute("sizes", d); c.detail.dataAttr || w(a, c.detail) }), e = function (a, b, d) { var e, f = a.parentNode; f && (d = y(a, f, d), e = v(a, "lazybeforesizes", { width: d, dataAttr: !!b }), e.defaultPrevented || (d = e.detail.width) && d !== a._lazysizesWidth && c(a, f, e, d)) }, f = function () { var b, c = a.length; if (c) for (b = 0; b < c; b++)e(a[b]) }, g = C(f); return { _: function () { a = b.getElementsByClassName(d.autosizesClass), j("resize", g) }, checkElems: g, updateElem: e } }(), F = function () { F.i || (F.i = !0, E._(), D._()) }; return c = { cfg: d, autoSizer: E, loader: D, init: F, uP: w, aC: s, rC: t, hC: r, fire: v, gW: y, rAF: z } } });
  /*! ls.rias.min.ks - v4.1.8 */
  !function (a, b) { var c = function () { b(a.lazySizes), a.removeEventListener("lazyunveilread", c, !0) }; b = b.bind(null, a, a.document), "object" == typeof module && module.exports ? b(require("lazysizes")) : a.lazySizes ? c() : a.addEventListener("lazyunveilread", c, !0) }(window, function (a, b, c) { "use strict"; function d(b, c) { var d, e, f, g, h = a.getComputedStyle(b); e = b.parentNode, g = { isPicture: !(!e || !m.test(e.nodeName || "")) }, f = function (a, c) { var d = b.getAttribute("data-" + a); if (!d) { var e = h.getPropertyValue("--ls-" + a); e && (d = e.trim()) } if (d) { if ("true" == d) d = !0; else if ("false" == d) d = !1; else if (l.test(d)) d = parseFloat(d); else if ("function" == typeof j[a]) d = j[a](b, d); else if (q.test(d)) try { d = JSON.parse(d) } catch (a) { } g[a] = d } else a in j && "function" != typeof j[a] ? g[a] = j[a] : c && "function" == typeof j[a] && (g[a] = j[a](b, d)) }; for (d in j) f(d); return c.replace(p, function (a, b) { b in g || f(b, !0) }), g } function e(a, b) { var c = [], d = function (a, c) { return k[typeof b[c]] ? b[c] : a }; return c.srcset = [], b.absUrl && (s.setAttribute("href", a), a = s.href), a = ((b.prefix || "") + a + (b.postfix || "")).replace(p, d), b.widths.forEach(function (d) { var e = b.widthmap[d] || d, f = b.aspectratio || b.ratio, g = !b.aspectratio && j.traditionalRatio, h = { u: a.replace(n, e).replace(o, f ? g ? Math.round(d * f) : Math.round(d / f) : ""), w: d }; c.push(h), c.srcset.push(h.c = h.u + " " + d + "w") }), c } function f(a, c, d) { var f = 0, g = 0, h = d; if (a) { if ("container" === c.ratio) { for (f = h.scrollWidth, g = h.scrollHeight; !(f && g || h === b);)h = h.parentNode, f = h.scrollWidth, g = h.scrollHeight; f && g && (c.ratio = g / f) } a = e(a, c), a.isPicture = c.isPicture, u && "IMG" == d.nodeName.toUpperCase() ? d.removeAttribute(i.srcsetAttr) : d.setAttribute(i.srcsetAttr, a.srcset.join(", ")), Object.defineProperty(d, "_lazyrias", { value: a, writable: !0 }) } } function g(a, b) { var e = d(a, b); return j.modifyOptions.call(a, { target: a, details: e, detail: e }), c.fire(a, "lazyriasmodifyoptions", e), e } function h(a) { return a.getAttribute(a.getAttribute("data-srcattr") || j.srcAttr) || a.getAttribute(i.srcsetAttr) || a.getAttribute(i.srcAttr) || a.getAttribute("data-pfsrcset") || "" } var i, j, k = { string: 1, number: 1 }, l = /^\-*\+*\d+\.*\d*$/, m = /^picture$/i, n = /\s*\{\s*width\s*\}\s*/i, o = /\s*\{\s*height\s*\}\s*/i, p = /\s*\{\s*([a-z0-9]+)\s*\}\s*/gi, q = /^\[.*\]|\{.*\}$/, r = /^(?:auto|\d+(px)?)$/, s = b.createElement("a"), t = b.createElement("img"), u = "srcset" in t && !("sizes" in t), v = !!a.HTMLPictureElement && !u; !function () { var b, d = function () { }, e = { prefix: "", postfix: "", srcAttr: "data-src", absUrl: !1, modifyOptions: d, widthmap: {}, ratio: !1, traditionalRatio: !1, aspectratio: !1 }; i = c && c.cfg || a.lazySizesConfig, i || (i = {}, a.lazySizesConfig = i), i.supportsType || (i.supportsType = function (a) { return !a }), i.rias || (i.rias = {}), "widths" in (j = i.rias) || (j.widths = [], function (a) { for (var b, c = 0; !b || b < 3e3;)c += 5, c > 30 && (c += 1), b = 36 * c, a.push(b) }(j.widths)); for (b in e) b in j || (j[b] = e[b]) }(), addEventListener("lazybeforesizes", function (a) { if (a.detail.instance == c) { var b, d, e, k, l, m, o, p, q, s, t, u, x; if (b = a.target, a.detail.dataAttr && !a.defaultPrevented && !j.disabled && (q = b.getAttribute(i.sizesAttr) || b.getAttribute("sizes")) && r.test(q)) { if (d = h(b), e = g(b, d), t = n.test(e.prefix) || n.test(e.postfix), e.isPicture && (k = b.parentNode)) for (l = k.getElementsByTagName("source"), m = 0, o = l.length; m < o; m++)(t || n.test(p = h(l[m]))) && (f(p, e, l[m]), u = !0); t || n.test(d) ? (f(d, e, b), u = !0) : u && (x = [], x.srcset = [], x.isPicture = !0, Object.defineProperty(b, "_lazyrias", { value: x, writable: !0 })), u && (v ? b.removeAttribute(i.srcAttr) : "auto" != q && (s = { width: parseInt(q, 10) }, w({ target: b, detail: s }))) } } }, !0); var w = function () { var d = function (a, b) { return a.w - b.w }, e = function (a) { var b, c, d = a.length, e = a[d - 1], f = 0; for (f; f < d; f++)if (e = a[f], e.d = e.w / a.w, e.d >= a.d) { !e.cached && (b = a[f - 1]) && b.d > a.d - .13 * Math.pow(a.d, 2.2) && (c = Math.pow(b.d - .6, 1.6), b.cached && (b.d += .15 * c), b.d + (e.d - a.d) * c > a.d && (e = b)); break } return e }, f = function (a, b) { var d; return !a._lazyrias && c.pWS && (d = c.pWS(a.getAttribute(i.srcsetAttr || ""))).length && (Object.defineProperty(a, "_lazyrias", { value: d, writable: !0 }), b && a.parentNode && (d.isPicture = "PICTURE" == a.parentNode.nodeName.toUpperCase())), a._lazyrias }, g = function (b) { var d = a.devicePixelRatio || 1, e = c.getX && c.getX(b); return Math.min(e || d, 2.4, d) }, h = function (b, c) { var h, i, j, k, l, m; if (l = b._lazyrias, l.isPicture && a.matchMedia) for (i = 0, h = b.parentNode.getElementsByTagName("source"), j = h.length; i < j; i++)if (f(h[i]) && !h[i].getAttribute("type") && (!(k = h[i].getAttribute("media")) || (matchMedia(k) || {}).matches)) { l = h[i]._lazyrias; break } return (!l.w || l.w < c) && (l.w = c, l.d = g(b), m = e(l.sort(d))), m }, j = function (d) { if (d.detail.instance == c) { var e, g = d.target; if (!u && (a.respimage || a.picturefill || lazySizesConfig.pf)) return void b.removeEventListener("lazybeforesizes", j); ("_lazyrias" in g || d.detail.dataAttr && f(g, !0)) && (e = h(g, d.detail.width)) && e.u && g._lazyrias.cur != e.u && (g._lazyrias.cur = e.u, e.cached = !0, c.rAF(function () { g.setAttribute(i.srcAttr, e.u), g.setAttribute("src", e.u) })) } }; return v ? j = function () { } : addEventListener("lazybeforesizes", j), j }() });
}

var notFirst = !1,
    onSale = !1,
    soldOut = !1,
    priceVaries = !1,
    images = [],
    firstVariant = {},
    bcSfFilterSettings = {
        general: {
            limit: bcSfFilterConfig.custom.products_per_page,
            loadProductFirst: false
        }
    },
    bcSfFilterTemplate = {
        soldOutClass: "",
        soldOutClassAjax: "sold-out",
        saleClass: " on-sale",
        soldOutLabelHtml: "",
        saleLabelHtml: "<span class=\"sale bc-sf-filter-label\">" + bcSfFilterConfig.label_basic.sale + "</span>",
        tagLabelHtml: "<span class=\"tag bc-sf-filter-label {{labelTag}}\" >{{labelTag}}</span>",
        vendorHtml: "<p class=\"bc-sf-filter-product-item-vendor\">{{itemVendorLabel}}</p>",
      	productGridItemHtml: "<div boost-item='{{itemId}}' data-handle='{{itemHandle}}' class=\"bc-sf-filter-product-item bc-sf-filter-product-item-grid {{gridWidthClass}}{{soldOutClass}}{{saleClass}} {{itemActiveSwapClass}}\"><script class=\"bc-sf-filter-product-script\" data-id=\"bc-product-json-{{itemId}}\" type=\"application/json\">{{itemJson}}</script><div class=\"bc-sf-filter-product-item-inner\"><div class=\"bc-sf-filter-product-item-image\"><div data-flair-product-badge data-product-id=\"{{itemId}}\" data-layout=\"Overlay\"></div>{{itemWishlist}}<a href=\"{{itemUrl}}\" class=\"bc-sf-filter-product-item-image-link\">{{itemImages}}</a></div><div class=\"bc-sf-filter-product-item-label\"><span class=\"soldout soldout-hidden bc-sf-filter-label\" >" + bcSfFilterConfig.label_basic.sold_out + "</span>{{itemLabels}}{{itemTagLabels}}</div><div class=\"bc-sf-filter-product-bottom\"><ul class=\"list-colors js-image-change\">{{itemColors}}</ul><!-- /.list-colors --><a href=\"{{itemUrl}}\" class=\"bc-sf-filter-product-item-title\">{{itemTitle}}</a>{{itemVendor}}{{itemPrice}}<span class=\"stamped-product-reviews-badge\" data-id=\"{{itemId}}\"></span><div class=\"showroom-actions\">{{showroomActions}}</div></div></div></div>",
        productListItemHtml: "<div boost-item='{{itemId}}' class=\"bc-sf-filter-product-item bc-sf-filter-product-item-list {{soldOutClass}}{{saleClass}} {{itemActiveSwapClass}}\"><div class=\"bc-sf-filter-product-item-list-col-1\"><div class=\"bc-sf-filter-product-item-image\"><div class=\"bc-sf-filter-product-item-label\">{{itemLabels}}{{itemTagLabels}}</div><a href=\"{{itemUrl}}\" class=\"bc-sf-filter-product-item-image-link\">{{itemImages}}</a></div></div><div class=\"bc-sf-filter-product-bottom\"><div class=\"bc-sf-filter-product-item-list-col-2\"><a href=\"{{itemUrl}}\" class=\"bc-sf-filter-product-item-title\">{{itemTitle}}</a>{{itemVendor}}<p class=\"bc-sf-filter-des\">{{itemDescription}}</p></div><div class=\"bc-sf-filter-product-item-list-col-3\">{{itemPrice}}</div></div></div>",
        previousActiveHtml: "<li><a href=\"{{itemUrl}}\" rel=\"prev\"><i class=\"ico-arrow-left\"></i></a></li>",
        previousDisabledHtml: "<li class=\"disabled\"><span><i class=\"ico-arrow-left\"></i></span></li>",
        nextActiveHtml: "<li><a href=\"{{itemUrl}}\" rel=\"next\"><i class=\"ico-arrow-right\"></i></a></li>",
        nextDisabledHtml: "<li class=\"disabled\"><span><i class=\"ico-arrow-right\"></i></span></li>",
        pageItemHtml: "<li><a href=\"{{itemUrl}}\">{{itemTitle}}</a></li>",
        pageItemSelectedHtml: "<li><span class=\"active\">{{itemTitle}}</span></li>",
        pageItemRemainHtml: "<li><span>{{itemTitle}}</span></li>",
        paginateHtml: "<ul>{{previous}}{{pageItems}}{{next}}</ul>",
        sortingHtml: "<label>" + bcSfFilterConfig.label.sorting + "</label><select class=\"bc-sf-filter-filter-dropdown\">{{sortingItems}}</select>",
        showLimitHtml: "<label>" + bcSfFilterConfig.label.show_limit + "</label><select class=\"bc-sf-filter-filter-dropdown\">{{showLimitItems}}</select>",
        breadcrumbHtml: "<a href=\"/\">" + bcSfFilterConfig.label.breadcrumb_home + "</a> {{breadcrumbDivider}} {{breadcrumbItems}}",
        breadcrumbDivider: "<span class=\"divider\">/</span>",
        breadcrumbItemLink: "<a href=\"{{itemLink}}\">{{itemTitle}}</a>",
        breadcrumbItemSelected: "<span>{{itemTitle}}</span>"
    };

function prepareShopifyData(a) {
    soldOut = !a.available, onSale = a.compare_at_price_min > a.price_min, priceVaries = a.price_min != a.price_max, images = a.images_info;
    var b = a.variants[0];
    if (null !== getParam("variant") && "" != getParam("variant")) {
        var c = a.variants.filter(function(a) {
            return a.id == getParam("variant")
        });
        "undefined" != typeof c[0] && (b = c[0])
    } else
        for (var d = 0; d < a.variants.length; d++)
            if (a.variants[d].available) {
                b = a.variants[d];
                break
            } return a
}
BCSfFilter.prototype.buildExtrasProductListBadges = function(a, b) {
  // Builds our own badge list
  // Queues the sold out status update to as soon we end this function
  setTimeout(() => {
    $('.bc-sf-filter-product-item[data-handle]').each((i, o) => {
      var product = $(o);
      var handle = o.getAttribute('data-handle');
      $.get('/products/' + handle + '?view=availability', function (result) {
        var status = JSON.parse(result);

        // Checks if there was a valid server response (the request didn't fail for some reason)
        if (status && status.success) {
          // Sets availability
          if (status.available) {
            product.removeClass(bcSfFilterTemplate.soldOutClassAjax);
            product.find('.bc-sf-filter-label.soldout')
              .addClass('soldout-hidden')
              .addClass('hidden');
            product.find('.itemFlair')
              .removeClass('hidden');
          } else {
            product.addClass(bcSfFilterTemplate.soldOutClassAjax);
            product.find('.bc-sf-filter-label.soldout')
              .removeClass('soldout-hidden')
              .removeClass('hidden');
            product.find('.itemFlair')
              .addClass('hidden');
          }
        }
      });
    });
  }, 1);
}
BCSfFilter.prototype.buildProductGridItem = function(a) {
    var b = bcSfFilterTemplate.productGridItemHtml;
    a = prepareShopifyData(a);
    var c = soldOut ? bcSfFilterTemplate.soldOutClass : "",
        d = onSale ? bcSfFilterTemplate.saleClass : "";


  // Force image sizes to use a size similar to 700px width, because it uses a full size image by default
    let imagesAr = [];
    a.images.forEach(function(img) {
      let src = img.src;
      img.original_src = src;

      if( src.indexOf('_360x') < 0 ) {
        let ratio = img.height / img.width;
        img.height = ratio * 360;
        img.width = 360;

        let srcAr = [];
        let ext = '.jpg';
        if( src.indexOf('.jpg') > -1 ) {
          srcAr = src.split('.jpg');
        }
        else {
          srcAr = src.split('.png');
          ext = '.png';
        }

        if( srcAr.length > 0 ) {
          srcAr[0] = srcAr[0] + '_360x';
          img.src = srcAr[0] + ext + srcAr[1];
          img.src = img.src.replace('_360x_360x', '_360x');
        }
      }

      imagesAr.push(img);
    });
    a.images = imagesAr;

    let builtImages = buildImages(a);


    b = b.replace(/{{soldOutClass}}/g, c), b = b.replace(/{{saleClass}}/g, d), b = b.replace(/{{gridWidthClass}}/g, buildGridWidthClass(a)), b = b.replace(/{{itemLabels}}/g, buildLabels(a)), b = b.replace(/{{itemTagLabels}}/g, buildTagLabels(a, !1)), b = b.replace(/{{itemImages}}/g, builtImages), b = b.replace(/{{itemPrice}}/g, buildPrice(a)), b = b.replace(/{{itemVendor}}/g, buildVendor(a));
    var e = bcSfFilterConfig.custom.active_image_swap ? "has-bc-swap-image" : "";
    b = b.replace(/{{itemActiveSwapClass}}/g, e);
    var f = this,
        g = {
            id: a.id,
            title: a.title,
            handle: a.handle,
            vendor: a.vendor,
            variants: a.variants,
            url: f.buildProductItemUrl(a),
            options_with_values: a.options_with_values,
            images: a.images,
            available: a.available,
            price_min: a.price_min,
            price_max: a.price_max,
            compare_at_price_min: a.compare_at_price_min,
            compare_at_price_max: a.compare_at_price_max
        };
    b = b.replace(/{{itemJson}}/g, JSON.stringify(g));
    var h = "<!-- include 'wishlist-button-collection' with '" + a.id + "' -->";
    b = b.replace(/{{itemWishlist}}/g, h);
    b = b.replace(/{{itemId}}/g, a.id);
    b = b.replace(/{{itemTitle}}/g, a.title);
    b = b.replace(/{{itemHandle}}/g, a.handle);
    b = b.replace(/{{itemVendorLabel}}/g, a.vendor);
    b = b.replace(/{{itemUrl}}/g, this.buildProductItemUrl(a));
    b = b.replace(/{{itemColors}}/g, buildColors(a));

    // Adds Showroom button
    b = b.replace(/{{showroomActions}}/g, window.buildShowroomProductActions ? window.buildShowroomProductActions(a) : '');
    
    // Returns built item
    return b;
}, BCSfFilter.prototype.buildProductListItem = function(a) {


  // Force image sizes to use a size similar to 700px width, because it uses a full size image by default
  let imagesAr = [];
  a.images.forEach(function(img) {
    let src = img.src;
    img.original_src = src;

    if( src.indexOf('_360x') < 0 ) {
      let ratio = img.height / img.width;
      img.height = ratio * 360;
      img.width = 360;

      let srcAr = [];
      let ext = '.jpg';
      if( src.indexOf('.jpg') > -1 ) {
        srcAr = src.split('.jpg');
      }
      else {
        srcAr = src.split('.png');
        ext = '.png';
      }

      if( srcAr.length > 0 ) {
        srcAr[0] = srcAr[0] + '_360x';
        img.src = srcAr[0] + ext + srcAr[1];
        img.src = img.src.replace('_360x_360x', '_360x');
      }
    }

    imagesAr.push(img);
  });
  a.images = imagesAr;
  let builtImages = buildImages(a);



    var b = a.images_info,
        c = !a.available,
        d = a.compare_at_price_min > a.price_min,
        e = a.price_min != a.price_max,
        f = a.variants[0];
    if (null !== getParam("variant") && "" != getParam("variant")) {
        var g = a.variants.filter(function(a) {
            return a.id == getParam("variant")
        });
        "undefined" != typeof g[0] && (f = g[0])
    } else
        for (var h = 0; h < a.variants.length; h++)
            if (a.variants[h].available) {
                f = a.variants[h];
                break
            } var j = bcSfFilterTemplate.productListItemHtml;
    a = prepareShopifyData(a);
    var k = c ? bcSfFilterTemplate.soldOutClass : "",
        l = d ? bcSfFilterTemplate.saleClass : "";
    j = j.replace(/{{soldOutClass}}/g, k), j = j.replace(/{{saleClass}}/g, l), j = j.replace(/{{itemLabels}}/g, buildLabels(a)), j = j.replace(/{{itemTagLabels}}/g, buildTagLabels(a, !1)), j = j.replace(/{{itemImages}}/g, builtImages), j = j.replace(/{{itemVendor}}/g, buildVendor(a));
    var m = buildPrice(a, d, e);
    j = j.replace(/{{itemPrice}}/g, m);
    var n = jQ("<p>" + a.body_html + "</p>").text();
    n = 40 < n.split(" ").length ? n.split(" ").splice(0, 40).join(" ") + "..." : n.split(" ").splice(0, 40).join(" "), j = j.replace(/{{itemDescription}}/g, n);
    var o = bcSfFilterConfig.custom.active_image_swap ? "has-bc-swap-image" : "";
    return j = j.replace(/{{itemActiveSwapClass}}/g, o), j = j.replace(/{{itemTitle}}/g, a.title), j = j.replace(/{{itemVendorLabel}}/g, a.vendor), j = j.replace(/{{itemUrl}}/g, this.buildProductItemUrl(a)), j
};

/*
function buildColors(a) {
    for (var b = [], c = window.productColors, d = a.options_with_values, e = a.variants, f = window.location.pathname.split("/")[window.location.pathname.split("/").length - 1], g = a.images_info, h = 0, k = 0; k < a.options_with_values.length; k++) "color" == a.options_with_values[k].name && (h = a.options_with_values[k].values.length);
    for (var k = 0; 3 > k; k++)
        if (void 0 !== d[k] && "color" === d[k].name)
            for (var m = 3 > h ? h : 3, n = [], o = 0; o < e.length; o++) {
                var p = [],
                    q = "option" + (k + 1);
                if (void 0 !== e[o]) {
                    var r = e[o][q].toLowerCase().replace(" ", "-").replace("/", "-").replace("\\", "-");
                    if (-1 == n.indexOf(r) && 3 > n.length) {
                        for (var s = 0; s < c.length; s++) c[s].hasOwnProperty(r) && (p.push(e[o].image, c[s][r], e[o].id, r), b.push(p));
                        n.push(r)
                    }
                }
            }
    var t = "",
        u = "class=\"current\"";
    notFirst && (u = "");
    for (var k = 0; k < b.length; k++) {
        if (0 != k && (u = ""), null !== b[k][0]) var v = "<li " + u + "><span data-image=\"" + b[k][0] + "\" style=\"background: " + b[k][1] + ";\" data-variant-id=\"" + b[k][2] + "\" data-name-handle=\"" + b[k][3] + "\"></span></li>";
        else var v = "<li " + u + "><span data-name-handle=\"" + b[k][3] + "\" style=\"background: " + b[k][1] + ";\"></span></li>";
        t += v
    }
    var w = 1 < h ? h + " Colors" : h + " Color";
    return t = t + "<li><p>" + w + "</p></li>", t
}
*/

function getColorCode(name){
    if(name == 'Strom' || name == 'strom'){
      name = 'storm';
    }
	var allColors = window.productColors;
    for(var i = 0; i < allColors.length; i++){
      if(name.toLowerCase().replace("/","-").replace(" ","-") == allColors[i].name.toLowerCase().replace("/","-").replace(" ","-")){
        var myKey = name.toLowerCase().replace("/","-").replace(" ","-");
		return allColors[i][myKey];
      }
    }
  	return;
}

function buildColors(data) {
  	var currentImage = '';
    var filteredUrl = new URL(window.location.href);
    var colorParam = filteredUrl.searchParams.getAll("pf_opt_color");
    var swatchesHtml = '';
  	var collectionHandle = "";
  	if(bcSfFilterMainConfig.general.collection_handle.includes("color-")){
      collectionHandle = bcSfFilterMainConfig.general.collection_handle.replace("color-","").replace('-', ' ');
    }
    for (var k in data.options) {
        var option = data['options'][k];
        var optionHandle = bcsffilter.slugify(option);
        var optionIndex = k;

        var isColor = false;
        var downcasedOption = option.toLowerCase();
        if (downcasedOption.indexOf('color') > -1 || downcasedOption.indexOf('colour') > -1) {
            var values = '';
          	var indexOfColor = 0;
            if(colorParam.length > 0){
              for (var i = 0; i < data.variants.length; i++) {
                  if(colorParam[0] == data['variants'][i]['options'][optionIndex]){
                    indexOfColor = i;
                  }
              }
            }else{
              if(collectionHandle !== ""){
                for (var i = 0; i < data.variants.length; i++) {
                    if(collectionHandle == data['variants'][i]['options'][optionIndex].toLowerCase()){
                      indexOfColor = i;
                    }
                }
              }
            }

            if(data.variants.length > 3){
              if(indexOfColor >= 1 && indexOfColor < data.variants.length - 1){
                for (var i in data.variants) {
                    var variant = data['variants'][i];

                    var value = variant['options'][optionIndex];
                    var wrappedValue = ',' + value + ',';
                    if(i == parseInt(indexOfColor) || i == parseInt(indexOfColor) - 1 || i == parseInt(indexOfColor) + 1){
                      var classCurrent = "";
                      if(i == parseInt(indexOfColor)){
                        classCurrent = "class='current'";
                      }
                      variant.image = fixImgSize(variant.image);

                      let colorCode = getColorCode(bcsffilter.slugify(value));

                      let colorCSSRule;
                      if(typeof colorCode !== "undefined"){
                        colorCSSRule = colorCode.indexOf('gradient') > -1 ? 'background-image' : 'background-color';
                      }else{
                        colorCSSRule = 'background-color';
                      }
                      swatchesHtml += '<li '+classCurrent+'>';
                      swatchesHtml += '<span title="' + value + '" data-variant-id="'+variant.id+'" data-image="'+variant.image+'" data-name-handle="'+ value +'" data-option-title="' + value + '" style="' + colorCSSRule + ': ' + colorCode + '"></span>';
                      swatchesHtml += '</li>';
                    }
                }
              } else if(indexOfColor >= data.variants.length - 1) {
              	for (var i in data.variants) {
                    var variant = data['variants'][i];

                  variant.image = fixImgSize(variant.image);

                    var value = variant['options'][optionIndex];
                    var wrappedValue = ',' + value + ',';
                    if(i == parseInt(indexOfColor) || i == parseInt(indexOfColor) - 1 || i == parseInt(indexOfColor) - 2){
                      var classCurrent = "";
                      if(i == parseInt(indexOfColor)){
                        classCurrent = "class='current'";
                      }
                      if (values.indexOf(wrappedValue) == -1) {
                      let colorCode = getColorCode(bcsffilter.slugify(value));
                      let colorCSSRule = typeof colorCode != "undefined" && colorCode.indexOf('gradient') > -1 ? 'background-image' : 'background-color';
                      if (values.indexOf(wrappedValue) == -1) {
                              swatchesHtml += '<li '+classCurrent+'>';
                              swatchesHtml += '<span title="' + value + '" data-variant-id="'+variant.id+'" data-image="'+variant.image+'" data-name-handle="'+ value +'" data-option-title="' + value + '" style="' + colorCSSRule + ': ' + colorCode + '"></span>';
                              swatchesHtml += '</li>';
                          values += wrappedValue;
                      }
                    }
                  }
                }
              }else{
                for (var i in data.variants) {
                    var variant = data['variants'][i];

                    var value = variant['options'][optionIndex];
                    var wrappedValue = ',' + value + ',';
                    if(i == 0 || i == 1 || i == 2){
                      var classCurrent = "";
                      if(i == parseInt(indexOfColor)){
                        classCurrent = "class='current'";
                      }
                      variant.image = fixImgSize(variant.image);
                      let colorCode = getColorCode(bcsffilter.slugify(value));
                      let colorCSSRule;
                      if(typeof colorCode !== "undefined"){
                        colorCSSRule = colorCode.indexOf('gradient') > -1 ? 'background-image' : 'background-color';
                      }else{
                        colorCSSRule = 'background-color';
                      }
                      swatchesHtml += '<li '+classCurrent+'>';
                      swatchesHtml += '<span title="' + value + '" data-variant-id="'+variant.id+'" data-image="'+variant.image+'" data-name-handle="'+ value +'" data-option-title="' + value + '" style="' + colorCSSRule + ': ' + colorCode + ';"></span>';
                      swatchesHtml += '</li>';
                    }
                }
              }
            }else{
              for (var i in data.variants) {
                var variant = data['variants'][i];
                var value = variant['options'][optionIndex];
                var wrappedValue = ',' + value + ',';
                var classCurrent = "";
                if(i == parseInt(indexOfColor)){
                  classCurrent = "class='current'";
                }
                variant.image = fixImgSize(variant.image);
                let colorCode = getColorCode(bcsffilter.slugify(value));
                let colorCSSRule;
                if(typeof colorCode !== "undefined"){
                	colorCSSRule = colorCode.indexOf('gradient') > -1 ? 'background-image' : 'background-color';
                }else{
                	colorCSSRule = 'background-color';
                }
                swatchesHtml += '<li '+classCurrent+'>';
                swatchesHtml += '<span title="' + value + '" data-variant-id="'+variant.id+'" data-image="'+variant.image+'" data-name-handle="'+ value +'" data-option-title="' + value + '" style="' + colorCSSRule + ': ' + colorCode + '"></span>';
                swatchesHtml += '</li>';
              }
            }

            let totalColors = data.product_type != 'Sample Dress' ? data.variants.length : data.variants.filter((variant) => variant.inventory_quantity > 0).length;
            let totalColorsText = data.product_type != 'Sample Dress' ? `${totalColors} Color${totalColors > 1 ? 's' : ''}` : 'Loading...';
            swatchesHtml += `<li><p>${totalColorsText}</p></li>`;
        }
    }
    return swatchesHtml;
}

function fixImgSize(src) {
  if(src === null) return src;
  let srcAr = [];
  let ext = '.jpg';
  let newSrc = src;
  if( src.indexOf('_360x') < 0 ) {
    if( src.indexOf('.jpg') > -1 ) {
      srcAr = src.split('.jpg');
    }
    else {
      srcAr = src.split('.png');
      ext = '.png';
    }
    if( srcAr.length > 0 ) {
      srcAr[0] = srcAr[0] + '_360x';
      newSrc = srcAr[0] + ext + srcAr[1];
    }
  }
  newSrc = newSrc.replace('_360x_360x', '_360x');
  return newSrc;
}

function buildGridWidthClass() {
    var a = "";
    switch (bcSfFilterConfig.custom.products_per_row) {
        case 2:
            a = "bc-sf-filter-grid-width-2";
            break;
        case 3:
            a = "bc-sf-filter-grid-width-3";
            break;
        case 5:
            a = "bc-sf-filter-grid-width-5";
            break;
        default:
            a = "bc-sf-filter-grid-width-4";
    }
    switch (bcSfFilterConfig.custom.products_per_row_mobile) {
        case 1:
            a += " bc-sf-filter-grid-width-mb-1";
            break;
        case 3:
            a += " bc-sf-filter-grid-width-mb-3";
            break;
        default:
            a += " bc-sf-filter-grid-width-mb-2";
    }
    return a
}

function getVariantImageByColor(variants, color){
  // Let's first try and find the proper variant
  const colorMatchingVariants = variants.filter(
    (variant) => (variant.option_color || '').toLowerCase() === color.toLowerCase()
  );

  // This is our resulting variant, it will be either the exactly matched variant from above, or the first variant in the set
  const variant = [
    ...colorMatchingVariants,
    ...variants,
  ][0];

  return variant 
    ? variant.image
    : null;
}

function buildImages(a) {
  	var filteredUrl = new URL(window.location.href);
    var colorParam = filteredUrl.searchParams.getAll("pf_opt_color");
  	var currentImage = "";
  	var collectionHandle = '';
    if(bcSfFilterMainConfig.general.collection_handle.includes("color-") && !bcSfFilterMainConfig.general.collection_handle.includes("swatches")){
      collectionHandle = bcSfFilterMainConfig.general.collection_handle.replace("color-","").replace('-', ' ');
    }
    if(collectionHandle == '' && filteredUrl.pathname != '' && filteredUrl.pathname.includes('/collections/')) {
      collectionHandle = filteredUrl.pathname.replace('/collections/', '').split('/')[0];
    }

    if (collectionHandle.includes('plus')) {
      // This is necessary so that the code below handles variant selection on plus size collections
      currentImage = null;
    } else if (colorParam.length > 0){
      // Selects by color query
      currentImage = getVariantImageByColor(a.variants, colorParam[colorParam.length - 1]);
    } else if (collectionHandle !== "") {
      // Selects by collection (Shop by Color)
    	currentImage = getVariantImageByColor(a.variants, collectionHandle);
    }

    var b = "",
        c = "",
        d = a.variants[0].image,
        e = window.location.href,
        f = e.split("&pf_"),
        g = !1,
        h = "none",
        j = "";
  var aspect_ratio , src , dataSrc , dataSrcSet , dataSizes , srcSet;

  if(images.length === 0){
  	aspect_ratio;
  	src = bcSfFilterConfig.general.no_image_url;
    dataSrc = bcsffilter.optimizeImage(bcSfFilterConfig.general.no_image_url, "50x");
    dataSrcSet = bcsffilter.optimizeImage(bcSfFilterConfig.general.no_image_url , '100x') + ' 100w, ' + bcsffilter.optimizeImage(bcSfFilterConfig.general.no_image_url , '400x') + ' 400w,   ' +bcsffilter.optimizeImage(bcSfFilterConfig.general.no_image_url , '500x') + ' 500w' ;
  	dataSizes = "auto";
  	srcSet = dataSrcSet;
    b += '<img src="'+ src +'" data-src="' + dataSrc + '" ';
    b += 'data-srcset="' + dataSrcSet + '" data-aspectratio="'+ aspect_ratio +'" data-sizes="auto" srcset="'+srcSet+'" ';
    b += " class=\"transition--blur-up bc-sf-filter-product-item-main-image product-item__image-main lazyload\"  data-variant-id=\"" + h + "\" data-sizes=\"auto\" />"
    if(bcSfFilterConfig.custom.active_image_swap) {
          if(images.length > 1){
            var src= bcsffilter.optimizeImage(bcSfFilterConfig.general.no_image_url, "50x");
            dataSrc = bcsffilter.optimizeImage(src, '360x');
            dataSrcSet = bcsffilter.optimizeImage(src , '100x') + ' 100w, ' + bcsffilter.optimizeImage(src , '300x') + ' 300w,   ' +bcsffilter.optimizeImage(src , '400x') + ' 400w' ;
            dataSizes = "auto";
            var srcSet = dataSrcSet;
          }
          	b +='<img src="'+ src +'" data-src="' + dataSrc + '" ';
            b += 'data-srcset="' + dataSrcSet + '" data-aspectratio="'+ aspect_ratio +'" data-sizes="auto" srcset="'+srcSet+'" ';
            b += " class=\"transition--blur-up  bc-sf-filter-product-item-flip-image product-item__image-main lazyload\" data-sizes=\"auto\" />"
      }
    return b
  }else if (images.length > 0) {
    if(currentImage !== "" && typeof currentImage !== "undefined" && currentImage != null ){
      aspect_ratio = images[0]['width'] / images[0]['height'];
      //src= bcsffilter.optimizeImage(currentImage, "50x");
      src= currentImage;
      //dataSrc = bcsffilter.optimizeImage(currentImage, '900x');
      dataSrc = currentImage;
      dataSrcSet = bcsffilter.optimizeImage(currentImage , '100x') + ' 100w, ' + bcsffilter.optimizeImage(currentImage , '300x') + ' 300w,   ' +bcsffilter.optimizeImage(currentImage , '400x') + ' 400w' ;
      dataSizes = "auto";
      srcSet = dataSrcSet;
      b += '<img src="'+ src +'" data-src="' + dataSrc + '" ';
      b += 'data-srcset="' + dataSrcSet + '" data-aspectratio="'+ aspect_ratio +'" data-sizes="auto" srcset="'+srcSet+'" ';
      b += " class=\"transition--blur-up bc-sf-filter-product-item-main-image product-item__image-main lazyload\"  data-variant-id=\"" + h + "\" data-sizes=\"auto\" />"
      if(bcSfFilterConfig.custom.active_image_swap) {
          if(images.length > 1){
            //src= bcsffilter.optimizeImage(currentImage, "50x");
            src= currentImage;
            //dataSrc = bcsffilter.optimizeImage(currentImage, '900x');
            dataSrc = currentImage;
            dataSrcSet = bcsffilter.optimizeImage(currentImage , '100x') + ' 100w, ' + bcsffilter.optimizeImage(currentImage , '300x') + ' 300w,   ' +bcsffilter.optimizeImage(currentImage , '400x') + ' 400w' ;
            dataSizes = "auto";
            var srcSet = dataSrcSet;
          }
          	b +='<img src="'+ src +'" data-src="' + dataSrc + '" ';
            b += 'data-srcset="' + dataSrcSet + '" data-aspectratio="'+ aspect_ratio +'" data-sizes="auto" srcset="'+srcSet+'" ';
            b += " class=\"transition--blur-up  bc-sf-filter-product-item-flip-image product-item__image-main lazyload\" data-sizes=\"auto\" />"
      }
      return b
    }else{
      let workingImage = images[0];

      if(collectionHandle.includes('plus')) {
        for(let i=0; i<images.length; i++) {
          if(images[i].alt != null && images[i].alt.includes('**plus**')) {
            workingImage = images[i];
            break;
          }
        }
      }

    	aspect_ratio = workingImage['width'] / workingImage['height'];
        //src= bcsffilter.optimizeImage(workingImage.src, "50x");
        src= workingImage.src;
        //dataSrc = bcsffilter.optimizeImage(workingImage.src, '900x');
        dataSrc = workingImage.src;
        dataSrcSet = bcsffilter.optimizeImage(workingImage.original_src , '100x') + ' 100w, ' + bcsffilter.optimizeImage(workingImage.original_src , '300x') + ' 300w,   ' +bcsffilter.optimizeImage(workingImage.original_src , '400x') + ' 400w' ;
        dataSizes = "auto";
        srcSet = dataSrcSet;
      	b += '<img src="'+ src +'" data-src="' + dataSrc + '" ';
        b += 'data-srcset="' + dataSrcSet + '" data-aspectratio="'+ aspect_ratio +'" data-sizes="360w" srcset="'+srcSet+'" ';
        b += " class=\"transition--blur-up bc-sf-filter-product-item-main-image product-item__image-main lazyload\"  data-variant-id=\"" + h + "\" data-sizes=\"auto\" />"
        if(bcSfFilterConfig.custom.active_image_swap) {
          if(images.length > 1){
            //src= bcsffilter.optimizeImage(workingImage.src, "50x");
            src= images[1].src;
            //dataSrc = bcsffilter.optimizeImage(workingImage.src, '900x');
            dataSrc = images[1].src;
            var dataSrcSet = bcsffilter.optimizeImage(images[1].original_src , '100x') + ' 100w, ' + bcsffilter.optimizeImage(images[1].original_src , '300x') + ' 300w,   ' +bcsffilter.optimizeImage(images[1].original_src , '400x') + ' 400w' ;
            var dataAspectRatio = aspect_ratio;
            var dataSizes = "auto";
            var srcSet = dataSrcSet;
          }
          	b +='<img src="'+ src +'" data-src="' + dataSrc + '" ';
            b += 'data-srcset="' + dataSrcSet + '" data-aspectratio="'+ aspect_ratio +'" data-sizes="360w" srcset="'+srcSet+'" ';
            b += " class=\"transition--blur-up  bc-sf-filter-product-item-flip-image product-item__image-main lazyload\" data-sizes=\"auto\" />"
          }
   		return b
    }
 }
}

function buildVendor() {
    var a = "";
    return bcSfFilterConfig.custom.show_vendor && (a = bcSfFilterTemplate.vendorHtml), a
}

function buildPrice(a) {
    var b = "";
    if(typeof a.tags !== 'undefined' && a.tags.length > 0 && a.tags.includes('hidetag')) {
      return "<p class='product__contact'>Contact Us For Pricing</p>";
    }
    let klass = a.variants.length == 1 ? 'hide-starting-price' : '';
    return bcSfFilterConfig.custom.show_price && (b = "<p class=\"bc-sf-filter-product-item-price starting-price\">", onSale ? (b += "<s>" + bcsffilter.formatMoney(a.compare_at_price_min) + "</s> ", b += "<span class=\"bc-sf-filter-product-item-sale-price\"><span class=\"starting-at "+klass+"\">Starting At</span>" + bcsffilter.formatMoney(a.price_min) + "</span>") : (priceVaries && (b += bcSfFilterConfig.label_basic.from + " "), b += "<span class=\"bc-sf-filter-product-item-regular-price starting-price\"><span class=\"starting-at "+klass+"\">Starting At</span>" + bcsffilter.formatMoney(a.price_min) + "</span>"), b += "</p>"), b
}

function buildLabels() {
    var a = "";
    bcSfFilterConfig.custom.show_sold_out_label && soldOut && (a = bcSfFilterTemplate.soldOutLabelHtml.replace(/{{style}}/g, ""));
    var b = "";
    return bcSfFilterConfig.custom.show_sale_label && onSale && !soldOut && (b = bcSfFilterTemplate.saleLabelHtml.replace(/{{style}}/g, "")), a + b
}

function buildTagLabels(a, b) {
    if (b) {
        var c = "";
        if (a.tags)
            for (var d, e = 0; e < a.tags.length; e++)
                if (d = a.tags[e], -1 !== d.indexOf("pfs:label")) {
                    var f = bcSfFilterTemplate.tagLabelHtml.replace(/{{labelTag}}/g, d.split("pfs:label-")[1]);
                    c += f
                }
    } else {
        var c = "";
        if (a.tags)
            for (var e = a.tags.length - 1; 0 <= e; e--)
                if (d = a.tags[e], -1 !== d.indexOf("pfs:label")) {
                    var f = bcSfFilterTemplate.tagLabelHtml.replace(/{{labelTag}}/g, d.split("pfs:label-")[1]);
                    c += f;
                    break
                }
    }
    return c
}
BCSfFilter.prototype.buildPagination = function(a) {
    var b = parseInt(this.queryParams.page),
        c = Math.ceil(a / this.queryParams.limit);
    if (1 == c) return jQ(this.selector.pagination).html(""), !1;
    if ("default" == this.getSettingValue("general.paginationType")) {
        var d = bcSfFilterTemplate.paginateHtml,
            e = 1 < b ? bcSfFilterTemplate.previousActiveHtml : bcSfFilterTemplate.previousDisabledHtml;
        e = e.replace(/{{itemUrl}}/g, this.buildToolbarLink("page", b, b - 1)), d = d.replace(/{{previous}}/g, e);
        var f = b < c ? bcSfFilterTemplate.nextActiveHtml : bcSfFilterTemplate.nextDisabledHtml;
        f = f.replace(/{{itemUrl}}/g, this.buildToolbarLink("page", b, b + 1)), d = d.replace(/{{next}}/g, f);
        for (var g = [], h = b - 1; h > b - 3 && 0 < h; h--) g.unshift(h);
        0 < b - 4 && g.unshift("..."), 0 <= b - 4 && g.unshift(1), g.push(b);
        for (var i = [], j = b + 1; j < b + 3 && j <= c; j++) i.push(j);
        b + 3 < c && i.push("..."), b + 3 <= c && i.push(c);
        for (var k = "", l = g.concat(i), m = 0; m < l.length; m++) k += "..." == l[m] ? bcSfFilterTemplate.pageItemRemainHtml : l[m] == b ? bcSfFilterTemplate.pageItemSelectedHtml : bcSfFilterTemplate.pageItemHtml, k = k.replace(/{{itemTitle}}/g, l[m]), k = k.replace(/{{itemUrl}}/g, this.buildToolbarLink("page", b, l[m]));
        d = d.replace(/{{pageItems}}/g, k), jQ(this.selector.pagination).html(d)
    }
}, BCSfFilter.prototype.buildFilterSorting = function() {
    if (bcSfFilterConfig.custom.show_sorting && bcSfFilterTemplate.hasOwnProperty("sortingHtml")) {
        jQ(this.selector.topSorting).html("");
        var a = this.getSortingList();
        if (a) {
            var b = "";
            for (var c in a) b += "<option value=\"" + c + "\">" + a[c] + "</option>";
            var d = bcSfFilterTemplate.sortingHtml.replace(/{{sortingItems}}/g, b);
            jQ(this.selector.topSorting).html(d), jQ(this.selector.topSorting + " select").val(this.queryParams.sort)
        }
    }
}, BCSfFilter.prototype.buildFilterDisplayType = function() {
    jQ(".bc-sf-filter-product-item-inner").each(function() {
        var a = jQ(this),
            b = a.find("a"),
            c = a.find(".bc-sf-filter-product-item-main-image").data("variant-id");
        "none" != c && b.attr("href", `${b.attr("href").split("?variant=")[0]}?variant=${c}`)
    });
    var a = "<span>" + bcSfFilterConfig.label.toolbar_viewas + "</span>";
    a += "<a href=\"" + this.buildToolbarLink("display", "list", "grid") + "\" title=\"Grid view\" class=\"bc-sf-filter-display-item bc-sf-filter-display-grid\" data-view=\"grid\"><span class=\"icon-fallback-text\"><i class=\"fa fa-th\" aria-hidden=\"true\"></i><span class=\"fallback-text\">Grid view</span></span></a>", a += "<a href=\"" + this.buildToolbarLink("display", "grid", "list") + "\" title=\"List view\" class=\"bc-sf-filter-display-item bc-sf-filter-display-list\" data-view=\"list\"><span class=\"icon-fallback-text\"><i class=\"fa fa-list\" aria-hidden=\"true\"></i><span class=\"fallback-text\">List view</span></span></a>";
    var b = jQ(this.getSelector("topDisplayType")),
        c = jQ(this.getSelector("products"));
    b.html(a), b.find(".bc-sf-filter-display-item").removeClass("active"), "list" == this.queryParams.display ? (b.find(".bc-sf-filter-display-list").addClass("active"), c.removeClass("bc-sf-filter-grid-view-items").addClass("bc-sf-filter-list-view-items")) : "grid" == this.queryParams.display && (b.find(".bc-sf-filter-display-grid").addClass("active"), c.removeClass("bc-sf-filter-list-view-items").addClass("bc-sf-filter-grid-view-items"))
}, BCSfFilter.prototype.buildDisplayTypeEvent = function() {
    var a = this,
        b = jQ(this.getSelector("topDisplayType")),
        c = jQ(this.getSelector("products"));
    jQ(this.getSelector("topDisplayType") + " a").click(function(d) {
        d.preventDefault(), a.internalClick = !0, jQ(this).parent().children().removeClass("active"), jQ(this).addClass("active"), "list" == a.queryParams.display ? (b.find(".bc-sf-filter-display-list").addClass("active"), c.removeClass("bc-sf-filter-grid-view-items").addClass("bc-sf-filter-list-view-items")) : "grid" == a.queryParams.display && (b.find(".bc-sf-filter-display-grid").addClass("active"), c.removeClass("bc-sf-filter-list-view-items").addClass("bc-sf-filter-grid-view-items"));
        var e = jQ(this).attr("href");
        a.onChangeData(e, "display")
    })
}, BCSfFilter.prototype.buildFilterShowLimit = function() {
    if (bcSfFilterConfig.custom.show_limit && bcSfFilterTemplate.hasOwnProperty("showLimitHtml")) {
        jQ(this.selector.topShowLimit).html("");
        var a = this.getSettingValue("general.showLimitList");
        if ("" != a) {
            for (var b = "", c = a.split(","), d = 0; d < c.length; d++) b += "<option value=\"" + c[d].trim() + "\">" + c[d].trim() + "</option>";
            var e = bcSfFilterTemplate.showLimitHtml.replace(/{{showLimitItems}}/g, b);
            jQ(this.selector.topShowLimit).html(e), jQ(this.selector.topShowLimit + " select").val(this.queryParams.limit)
        }
    }
}, BCSfFilter.prototype.buildBreadcrumb = function(a) {
    if (bcSfFilterTemplate.hasOwnProperty("breadcrumbHtml")) {
        var b = "";
        if ("undefined" != typeof a && a.hasOwnProperty("collection")) {
            var c = a.collection;
            "undefined" != typeof this.collectionTags && null !== this.collectionTags ? (b += bcSfFilterTemplate.breadcrumbItemLink.replace(/{{itemLink}}/g, "/collections/" + c.handle).replace(/{{itemTitle}}/g, c.title), b += " {{breadcrumbDivider}} ", b += bcSfFilterTemplate.breadcrumbItemSelected.replace(/{{itemTitle}}/g, this.collectionTags[0])) : b += bcSfFilterTemplate.breadcrumbItemSelected.replace(/{{itemTitle}}/g, c.title)
        } else b += bcSfFilterTemplate.breadcrumbItemSelected.replace(/{{itemTitle}}/g, this.getSettingValue("label.defaultCollectionHeader"));
        var d = bcSfFilterTemplate.breadcrumbHtml.replace(/{{breadcrumbItems}}/g, b);
        d = d.replace(/{{breadcrumbDivider}}/g, bcSfFilterTemplate.breadcrumbDivider), jQ(this.selector.breadcrumb).html(d)
    }
};

function matchHeightImage() {
    jQ(".bc-sf-filter-product-item-main-image").load(function() {
        var aspect_ratio = Number(jQ(this).attr('data-aspectratio'));
        var a = jQ(this).parent();
        a.css("width", "100%").css("aspect-ratio", "1 / " + 1 / aspect_ratio);
    }).each(function() {
        this.complete && jQ(this).load()
    })
}
BCSfFilter.prototype.buildExtrasProductList = function(data, evenType) {
  if(typeof StampedFn !== 'undefined') {
  	 StampedFn.loadBadges()
  }

  if (typeof FlairApp !== 'undefined' && FlairApp) { FlairApp.refreshProductBadges(); }
}, BCSfFilter.prototype.buildAdditionalElements = function(a) {
    var b = this,
        c = a.total_product + "<span> " + bcSfFilterConfig.label.items_with_count_other + "</span>";
    1 == a.total_product && (c = a.total_product + "<span> " + bcSfFilterConfig.label.items_with_count_one + "</span>"), jQ("#bc-sf-filter-total-product").html(c), matchHeightImage(), jQ(window).resize(function() {
        matchHeightImage()
    })

    if (typeof bcUpdateLazyLoad !== 'undefined') {
      var lazy = new bcUpdateLazyLoad.default({
        elements_selector: '.lazyload'
      });
      lazy.update();
    }


  jQ(".bc-sf-filter-product-bottom ul li span").on("click", function(){
      var variantSelectedImage = jQ(this).attr("data-image");
      if (variantSelectedImage && variantSelectedImage !== 'null') {
        jQ(this).closest(".bc-sf-filter-product-item-inner").find(".bc-sf-filter-product-item-image-link img").attr("src",variantSelectedImage).attr("srcset",variantSelectedImage).attr("data-src",variantSelectedImage).attr("data-srcset",variantSelectedImage);
      }
  });
};

function buildDefaultLink(d, a) {
    var b = window.location.href.split("?")[0];
    return b += "?" + d + "=" + a
}
BCSfFilter.prototype.buildDefaultElements = function() {
    if (bcSfFilterConfig.general.hasOwnProperty("collection_count") && 0 < jQ("#bc-sf-filter-bottom-pagination").length) {
        var a = bcSfFilterConfig.general.collection_count,
            b = parseInt(this.queryParams.page),
            c = Math.ceil(a / this.queryParams.limit);
        if (1 == c) return jQ(this.selector.pagination).html(""), !1;
        if ("default" == this.getSettingValue("general.paginationType")) {
            var d = bcSfFilterTemplate.paginateHtml,
                t = "";
            t = 1 < b ? bcSfFilterTemplate.hasOwnProperty("previousActiveHtml") ? bcSfFilterTemplate.previousActiveHtml : bcSfFilterTemplate.previousHtml : bcSfFilterTemplate.hasOwnProperty("previousDisabledHtml") ? bcSfFilterTemplate.previousDisabledHtml : "", t = t.replace(/{{itemUrl}}/g, buildDefaultLink("page", b - 1)), d = d.replace(/{{previous}}/g, t);
            var u = "";
            u = b < c ? bcSfFilterTemplate.hasOwnProperty("nextActiveHtml") ? bcSfFilterTemplate.nextActiveHtml : bcSfFilterTemplate.nextHtml : bcSfFilterTemplate.hasOwnProperty("nextDisabledHtml") ? bcSfFilterTemplate.nextDisabledHtml : "", u = u.replace(/{{itemUrl}}/g, buildDefaultLink("page", b + 1)), d = d.replace(/{{next}}/g, u);
            for (var v = [], h = b - 1; h > b - 3 && 0 < h; h--) v.unshift(h);
            0 < b - 4 && v.unshift("..."), 0 <= b - 4 && v.unshift(1), v.push(b);
            for (var w = [], j = b + 1; j < b + 3 && j <= c; j++) w.push(j);
            b + 3 < c && w.push("..."), b + 3 <= c && w.push(c);
            for (var x = "", y = v.concat(w), m = 0; m < y.length; m++) x += "..." == y[m] ? bcSfFilterTemplate.pageItemRemainHtml : y[m] == b ? bcSfFilterTemplate.pageItemSelectedHtml : bcSfFilterTemplate.pageItemHtml, x = x.replace(/{{itemTitle}}/g, y[m]), x = x.replace(/{{itemUrl}}/g, buildDefaultLink("page", y[m]));
            d = d.replace(/{{pageItems}}/g, x), jQ(this.selector.pagination).html(d)
        }
    }
    if (bcSfFilterTemplate.hasOwnProperty("sortingHtml") && 0 < jQ(this.selector.topSorting).length) {
        jQ(this.selector.topSorting).html("");
        var z = this.getSortingList();
        if (z) {
            var o = "";
            for (var A in z) o += "<option value=\"" + A + "\">" + z[A] + "</option>";
            var q = bcSfFilterTemplate.sortingHtml.replace(/{{sortingItems}}/g, o);
            jQ(this.selector.topSorting).html(q);
            var r = void 0 === this.queryParams.sort_by ? this.defaultSorting : this.queryParams.sort_by;
            jQ(this.selector.topSorting + " select").val(r), jQ(this.selector.topSorting + " select").change(function() {
                window.location.href = buildDefaultLink("sort_by", jQ(this).val())
            })
        }
    }
}, BCSfFilter.prototype.prepareProductData = function(a) {
    for (var b = 0; b < a.length; b++) {
        a[b].images = a[b].images_info, a[b].featured_image = 0 < a[b].images.length ? a[b].images[0] : {
            src: bcSfFilterConfig.general.no_image_url,
            width: "",
            height: "",
            aspect_ratio: 0
        }, a[b].url = "/products/" + a[b].handle;
        for (var c = [], d = 0; d < a[b].options_with_values.length; d++) c.push(a[b].options_with_values[d].name);
        a[b].options = c, a[b].price_min *= 100, a[b].price_max *= 100, a[b].compare_at_price_min *= 100, a[b].compare_at_price_max *= 100, a[b].price = a[b].price_min, a[b].compare_at_price = a[b].compare_at_price_min, a[b].price_varies = a[b].price_min != a[b].price_max;
        var e = a[b].variants[0];
        if (null !== getParam("variant") && "" != getParam("variant")) {
            var f = a.variants.filter(function(a) {
                return a.id == getParam("variant")
            });
            "undefined" != typeof f[0] && (e = f[0])
        } else
            for (var d = 0; d < a[b].variants.length; d++)
                if (a[b].variants[d].available) {
                    e = a[b].variants[d];
                    break
                } a[b].selected_or_first_available_variant = e;
        for (var d = 0; d < a[b].variants.length; d++) {
            var g = [],
                h = a[b].variants[d],
                l = h.merged_options;
            if (Array.isArray(l)) {
                for (var m, n = 0; n < l.length; n++) m = l[n].split(":"), a[b].variants[d]["option" + (parseInt(n) + 1)] = m[1], a[b].variants[d]["option_" + m[0]] = m[1], g.push(m[1]);
                a[b].variants[d].options = g
            }
            a[b].variants[d].compare_at_price = 100 * parseFloat(a[b].variants[d].compare_at_price), a[b].variants[d].price = 100 * parseFloat(a[b].variants[d].price)
        }
        a[b].description = a[b].content = a[b].body_html
    }
    return a
};


/* Start Fix version 2.3.2 */
BCSfFilter.prototype.addFilterTreeItem=function(e,r,t,i){e=jQ.parseHTML(e),i=void 0!==i?i:this.getSelector("filterTree");void 0!==r&&"before"==r?jQ(i+t).prepend(e):jQ(i+t).append(e)};
/* End Fix version 2.3.2 */

// Fix image url issue of swatch option
function getFilePath(fileName, ext, version) {
    var self = bcsffilter;
    var ext = typeof ext !== 'undefined' ? ext : 'png';
    var version = typeof version !== 'undefined' ? version : '1';
    var prIndex = self.fileUrl.lastIndexOf('?');
    if (prIndex > 0) {
        var filePath = self.fileUrl.substring(0, prIndex);
    } else {
        var filePath = self.fileUrl;
    }
    filePath += fileName + '.' + ext + '?v=' + version;
    return filePath;
}

